import elasticsearch from 'elasticsearch'
import AWS from 'aws-sdk/global'
import { store } from '../store/store.js'
import AWSConnector from 'http-aws-es'
import S3 from 'aws-sdk/clients/s3'

export default class House {
  constructor (id) {
    this.id = id
    this.parcel_id = []
    this.rental_info = []
    this.bedrooms = []
    this.bathrooms = []
    this.dining_description = []
    this.other_rooms = []
    this.basement = []
    this.heating = []
    this.fuel = []
    this.fireplaces = []
    this.cooling = []
    this.water = []
    this.sewer = []
    this.appliances = []
    this.outbuildings = []
    this.frontage = []
    this.garage = []
    this.roof = []
    this.exterior = []
    this.fence = []
    this.lot_features = []
    this.lot_description = []
    this.waterfront_view = []
    this.agricultural_water = []
    this.hoa_benefits = []
    this.shared_amenities = []
    this.unit_amenities = []
    this.handicap_access = []
    this.photos = []
    this.urls = []
    this.handicap_access = []
    this.tax_history = []
    this.price_history = []
    this.signedPhotos = {
      small: [],
      medium: [],
      large: []
    }
  }

  async getHouse () {
    if (!store.getters.getSecretAccessKey || !store.getters.getAccessKeyId) return
    AWS.config.update({
      credentials: new AWS.Credentials(store.getters.getAccessKeyId, store.getters.getSecretAccessKey, store.getters.getSessionToken),
      region: window.CONFIG.Region
    })
    try {
      var client = new elasticsearch.Client({
        connectionClass: AWSConnector,
        host: window.CONFIG.SearchDomain,
        apiVersion: '6.4'
      })
      const results = await client.search({
        index: 'house',
        type: '_doc',
        body: {
          size: 1,
          query: {
            term: {
              _id: this.id
            }
          }
        }
      })
      Object.keys(results.hits.hits[0]._source).forEach((key) => {
        this[key.toLowerCase()] = results.hits.hits[0]._source[key]
      })
      this.signPhotos()
    } catch (error) {
      console.log(error)
    }
  }

  signPhotos () {
    if (this.photos.length === 0) return
    var that = this
    var s3 = new S3()
    this.photos.sort()
    Object.keys(that.signedPhotos).forEach((key) => {
      that.photos.forEach((photoName) => {
        var photoArray = photoName.split('/')
        photoArray.shift()
        var photoKey = key + '/' + photoArray.join('/')
        var params = {
          Bucket: window.CONFIG.MLSPhotoBucketName,
          Key: photoKey
        }
        that.signedPhotos[key].push(s3.getSignedUrl('getObject', params))
      })
    })
  }

  pricePerSqft () {
    return parseInt(Number(this.price) / this.house_sqft)
  }

  listPriceStr () {
    return this.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  loc () {
    return new window.google.maps.LatLng(parseFloat(this.latitude), parseFloat(this.longitude))
  }

  daysOnHomApt () {
    var date = new Date(this.download_time)
    var currentDate = new Date()
    return Math.round((currentDate - date) / 86400000)
  }

  toSimpleObject () {
    let simpleObject = {}
    Object.keys(this).forEach((key) => {
      simpleObject[key] = this[key]
    })

    return simpleObject
  }
}



// WEBPACK FOOTER //
// ./src/lib/mlsApi.js